// const server = "http://localhost";
// const domain = "localhost";
// const port = 9351;
const serverImg = 'https://emanuel.nbg1.your-objectstorage.com/public';
const server = process.env.server || "https://testemanuel.mansolutions.app";
const port = process.env.port || 443;
const domain = process.env.domain || "emanuelimport.mansolutions.app";
export { server, port, domain, serverImg };
